package com.martdev.flickq.auth.model

data class Credentials(
    val email: String,
    val password: String
)
